import { api } from "./backend";

export const get = () => api.get("/front/specialities");

